import apiClient from '../index';

export const ecardApi = {
  // Get all templates
  getTemplates: async () => {
    try {
      // apiClient response interceptor already extracts response.data
      const data = await apiClient.get('/ecards/templates');

      if (data && data.data) {
        // Handle paginated or double-nested data payload: { data: { data: [...] } }
        const cardsArray = Array.isArray(data.data.data) ? data.data.data :
          Array.isArray(data.data) ? data.data : [];

        return cardsArray.map(card => ({
          id: card.id,
          event_id: card.event_id,
          name: card.name,
          event_type: card.event_type,
          card_category: card.card_category,
          price: card.price,
          wallpaper: card.preview_path,
          template_type: card.template_type,
          send_to_whatsapp: card.send_to_whatsapp ? 'Yes' : 'No'
        }));
      } else {
        console.error("Unexpected response structure:", data);
        return [];
      }
    } catch (error) {
      console.error("Could not fetch E-cards:", error);
      return [];
    }
  },

  // Search and filter templates (with pagination)
  searchTemplates: async (params = {}) => {
    try {
      const data = await apiClient.get('/ecards/templates', { params });

      if (data && data.data) {
        const responseData = data.data;
        const cardsArray = Array.isArray(responseData.data) ? responseData.data :
          Array.isArray(responseData) ? responseData : [];

        const pagination = responseData.current_page ? {
          current_page: responseData.current_page,
          per_page: responseData.per_page,
          total_records: responseData.total_records,
          total_pages: responseData.total_pages
        } : null;

        const templates = cardsArray.map(card => ({
          id: card.id,
          event_id: card.event_id,
          name: card.name,
          event_type: card.event_type,
          card_category: card.card_category,
          price: card.price,
          wallpaper: card.preview_path,
          template_type: card.template_type,
          send_to_whatsapp: card.send_to_whatsapp ? 'Yes' : 'No'
        }));

        return { templates, pagination };
      } else {
        return { templates: [], pagination: null };
      }
    } catch (error) {
      console.error("Could not fetch E-cards:", error);
      return { templates: [], pagination: null };
    }
  },

  // Get single template
  getTemplate: (id) => apiClient.get(`/ecards/templates/${id}`),

  // Get single template details
  getTemplateDetails: (id) => apiClient.get(`/ecards/get-template/${id}`),

  // Send generated cards by batch
  sendCard: (batch, data) => apiClient.post(`/ecards/send/${batch}`, data),

  // Get all generated cards for event (supports search query)
  getGeneratedCards: (params = {}) => {
    const searchParams = typeof params === 'string' ? { search: params } : params;
    return apiClient.get('/ecards/generated-ecards', { params: searchParams });
  },

  // Get generated cards for a specific batch
  getBatchDetails: (batch) => apiClient.get(`/ecards/batch/${batch}`),



  // Update card type
  updateCardType: (guestId, data) => apiClient.put(`/ecards/guest/${guestId}/type`, data),

  // Generate sample preview card
  generatePreview: (templateId, data = {}) => apiClient.post(`/ecards/generate-preview/${templateId}`, data),

  // Get resend price for ecard batch
  getResendPrice: () => apiClient.get('/ecard-resend-price'),


  // Admin template management
  createTemplate: (data) => apiClient.post('/admin/ecards/templates', data),
  updateTemplate: (id, data) => apiClient.put(`/admin/ecards/templates/${id}`, data),
  deleteTemplate: (id) => apiClient.delete(`/admin/ecards/templates/${id}`),

  // Download a generated card by card ID
  downloadCard: async (id, filename = `card-${id}.png`) => {
    const response = await apiClient.get(`/ecards/download/${id}`, {
      responseType: 'blob',
    });
    const blob = response instanceof Blob ? response : new Blob([response]);
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  },

  getCardBlob: async (id) => {
    const response = await apiClient.get(`/ecards/download/${id}`, {
      responseType: 'blob',
    });
    return response instanceof Blob ? response : new Blob([response]);
  },
};

export default ecardApi;